export enum statusList {
    WaitingForPayment = 1,
    WaitingPaymentApproval = 2,
    Active = 3,
    InActive= 4,
    Suspended = 5,
    Expired = 6,
    Withdrawn = 7
}
